import { EditorState } from 'draft-js';
import AnyAction from 'store/anyActions';
import { TasksState } from './tasks.state';
import TaskTypes from './tasks.types';

const defaultState: TasksState = {
    connections: [],
};

export default function (state: TasksState = defaultState, action: AnyAction): TasksState {
    switch (action.type) {
        case TaskTypes.ADD_TASK_CONNECTION:
            return {
                ...state,
                connections: [...state.connections, action.payload],
            };
        case TaskTypes.TASK_ACW:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload
                        ? { ...c, acw: true, acwStartTimestamp: Date.now(), status: connect.ContactStateType.ENDED }
                        : c
                ),
            };
        case TaskTypes.END_TASK:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload ? { ...c, status: connect.ContactStateType.ENDED } : c
                ),
            };

        case TaskTypes.ACCEPT_TASK:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload ? { ...c, accepting: true } : c
                ),
            };
        case TaskTypes.TASK_CONNECTED:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload
                        ? {
                            ...c,
                            status: connect.ContactStateType.CONNECTED,
                            started: Date.now(),
                            accepting: undefined,
                        }
                        : c
                ),
            };
        case TaskTypes.TASK_DISCONNECTED:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload ? { ...c, status: connect.ContactStateType.ENDED } : c
                ),
            };
        case TaskTypes.REMOVE_TASK_CONNECTION:
            return {
                ...state,
                connections: state.connections.filter(c => c.id !== action.payload),
            };
        //This case need for removing chat connection from store without following .destroy() api call
        // which present in listener on REMOVE_CHAT_CONNECTION action
        case TaskTypes.CLEAR_TASK_CONNECTION:
            return {
                ...state,
                connections: state.connections.filter(c => c.id !== action.payload),
            };
        case TaskTypes.TASK_MISSED:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload ? { ...c, status: connect.ContactStateType.MISSED } : c
                ),
            };
        case TaskTypes.COMPLETE_TASK_ACW:
            return {
                ...state,
                connections: state.connections.filter(c => c.id !== action.payload),
            };
        case TaskTypes.RECOVER_TASKS:
            return {
                ...state,
                connections: action.payload,
            };
        case TaskTypes.SET_TASK_REPLY_TEXT:
            return {
                ...state,
                connections: state.connections.map(c => {
                    if (c.id !== action.payload.id) return c;
                    return {
                        ...c,
                        reply: action.payload
                    }
                })
            }
        case TaskTypes.CLEAR_TASK_REPLY_TEXT:
            return {
                ...state,
                connections: state.connections.map(c => {
                    if (c.id !== action.payload.id) return c;
                    return {
                        ...c,
                        reply: undefined
                    }
                })
            }
        case TaskTypes.UPDATE_CONNECTION_EDITOR_CONTENT:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? { ...c, currentEditorContent: action.payload.content }
                        : c
                )
            }
        case TaskTypes.SEND_TASK_ATTACHMENT:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? {
                            ...c,
                            currentEditorContent: EditorState.createEmpty(),
                            attachments: []
                        }
                        : c
                )
            }
        case TaskTypes.SET_TASK_ATTACHMENT:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? {
                            ...c,
                            attachments:  [
                                ...c.attachments,
                                ...action.payload.attachments,
                            ]
                        }
                        : c
                )
            }
        case TaskTypes.DELETE_TASK_ATTACHMENT:
            return {
                ...state,
                connections: state.connections.map(c =>
                    c.id === action.payload.id
                        ? {
                            ...c,
                            attachments: [
                                ...c.attachments.filter((_, i) => action.payload.index !== i)
                            ]
                        }
                        : c
                )
            }

        case TaskTypes.SET_INCLUDE_CC_IN_REPLY:
            return {
                ...state,
                connections: state.connections.map((c) =>
                    c.id === action.payload.id
                        ? { ...c, includeCCInReply: action.payload.includeCCInReply }
                        : c,
                ),
            }

        default:
            return state;
    }
}
